import React from "react";
import { Badge, Table, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  PencilSquare,
  Trash
} from "react-bootstrap-icons";
import { formatShortDate } from "../../../utils/helper_functions";

function KeywordsTableList({
  tableData = [],
  handleEditTableRow,
  handleDeleteTableRow,
  isLoading
}) {
  //
  return (
    <div>
      {isLoading && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      <Table
        hover
        responsive
        striped
        style={{ opacity: isLoading ? 0.5 : 1, transition: "opacity 0.2s" }}
      >
        <thead>
          <tr>
          <td className="d-none d-md-table-cell">
              <small>ID</small>
            </td>
            <td>
              <small>Keyword</small>
            </td>
          
            <td>
              <small>Price</small>
            </td>
    
            <td className="d-none d-md-table-cell">
              <small>Code</small>
            </td>
            <td className="d-none d-md-table-cell">
              <small>Status</small>
            </td>

            <td className="d-none d-md-table-cell">
              <small>Updated</small>
            </td>
           
            {(typeof handleEditTableRow === "function" ||
              typeof handleDeleteTableRow === "function") && (
              <td>
                <small>Actions</small>
              </td>
            )}
          </tr>
        </thead>
        <tbody>
          {!tableData || tableData?.data?.data?.results.length < 1 ? (
            <tr>
              <td colSpan="18">
                <center>
                  <strong style={{ color: "orange" }}>
                    No Records To Display{" "}
                  </strong>
                </center>
              </td>
            </tr>
          ) : (
            tableData?.data?.data?.results.map((data, index) => (
              <tr key={index}>
                <td className="d-none d-md-table-cell">{data?.id}</td>
                <td>
                  <Link
                    to={"/keywords/detail"}
                    state={{ keywordId: data?.id }}
                    className="text-decoration-none"
                  >
                    {data?.keyword}
                  </Link><br/>
                  <small className='d-md-none'>{data?.shortcode}*{data?.code}</small>
                </td>

                
          
                <td>{data?.price}</td>
              
                <td className="d-none d-md-table-cell">{data?.shortcode}*{data?.code}</td>
                
                <td className="d-none d-md-table-cell">
                  {data?.is_active ? (
                    <Badge bg="success">Active</Badge>
                  ) : (
                    <Badge bg="secondary">Inactive</Badge>
                  )}
                </td>
               
                <td className="d-none d-md-table-cell">{formatShortDate(data?.updated)}</td>
                
                
                <td>
                  {typeof handleEditTableRow === "function" && (
                    <PencilSquare
                      style={{
                        cursor: isLoading ? "not-allowed" : "pointer",
                        color: isLoading ? "gray" : "blue",
                        opacity: isLoading ? 0.5 : 1,
                        marginRight: "1rem"
                      }}
                      onClick={
                        isLoading ? null : () => handleEditTableRow(data)
                      }
                    />
                  )}

                  {typeof handleDeleteTableRow === "function" && (
                    <Trash
                      style={{
                        cursor: isLoading ? "not-allowed" : "pointer",
                        color: isLoading ? "gray" : "red",
                        opacity: isLoading ? 0.5 : 1
                      }}
                      onClick={
                        isLoading ? null : () => handleDeleteTableRow(data)
                      }
                    />
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
}

export default KeywordsTableList;
